export default function checkDataFastResult(router, http, swal) {
    const urlParams = new URLSearchParams(window.location.search)
    const resourcePath = urlParams.get('resourcePath')
    const id = urlParams.get('id')

    if (resourcePath || id) {
        sessionStorage.removeItem('datafast_payment_component_active')
        const paymentData = sessionStorage.getItem('datafast_payment')
        const tokenizationData = sessionStorage.getItem('datafast_tokenization')

        if (tokenizationData) {
            return
        }

        if (!paymentData) {
            swal({
                title: 'Información Incompleta',
                text: 'No se pudo recuperar la información del pago.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
            })

            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            )
            return
        }

        let savedData = null
        try {
            savedData = JSON.parse(paymentData)
        } catch (parseError) {
            // Ignorar si no se puede parsear
        }

        const componentActive =
            sessionStorage.getItem('datafast_payment_component_active') ===
            'true'
        if (savedData?.handledByComponent && componentActive) {
            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            )
            return
        }
        try {
            const { checkoutData } = savedData || {}
            const finalResourcePath =
                resourcePath || `/v1/checkouts/${id}/payment`

            http.post('/datafast/checkout/process', {
                paymentId: checkoutData.paymentId,
                resourcePath: finalResourcePath,
            })
                .then((response) => {
                    if (response?.data?.success) {
                        const d = response.data.data || {}
                        const isSuccess = d.status === 'approved'

                        sessionStorage.removeItem('datafast_payment')
                        window.history.replaceState(
                            {},
                            document.title,
                            window.location.pathname
                        )

                        swal({
                            title: isSuccess
                                ? '✅ ¡Pago Exitoso! ¡Luki agradece tu pago!<br>En un momento tu pago será procesado<br> '
                                : '❌ Pago Rechazado',
                            text: d.message || 'Transacción procesada',
                            icon: isSuccess ? 'success' : 'error',
                            confirmButtonText: 'Aceptar',
                        })
                    }
                })
                .catch((error) => {
                    sessionStorage.removeItem('datafast_payment')
                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname
                    )

                    swal({
                        title: 'Error',
                        text:
                            error.response?.data?.error ||
                            'Error al procesar pago',
                        icon: 'error',
                    })
                })
        } catch (parseError) {
            // Error al procesar el resultado, se ignora silenciosamente
        }
    }
}
